const zh = {
    pageHeader: {
        pageHeader: {
            mobileHeader: {
                index: '首页',
                product: '产品',
                cpuProduct: '芯片产品',
                ipProduct: 'IP 产品',
                developer: '开发者',
                aboutRivai: '关于睿思',
                joinRivai: '加入睿思',
            },
            "cooperate": "合作咨询",
            "download": "资料下载"
        }
    },
    pageFooter: {
        wx: '微信公众号',
        processorProduct: '芯片产品',
        ipProduct: 'IP产品',
        founderProfile: '创始人简介',
        invest: '投资背书',

        slogan: '睿思芯科是一家基于 RISC-V 开源技术，为中高端市场提供核心处理器的芯片公司。',
        cooperate: '合作联系',
        mondayFriday: '周一到周五',
        copyRight: 'Copyright © 2018 - 2025 睿思芯科 Inc. 保留所有权利',
        number1: '粤 ICP 备 18130670 号-1',
        number2: '粤公网安备44030502003396号',
        btnList: {
            product: {
                title: '产品',
                lingyuCpu: '灵羽处理器',
                products: '系列IP产品',
            },
            env: {
                ecology: '生态',
                partner: '生态伙伴',
                product: '生态产品',
            },
            aboutRivai: {
                title: '关于睿思',
                introduce: "公司简介",
                devProgress: "发展历程",
                honor: "荣誉与奖项",
                contact: "联系我们",
                join: "加入我们",
                wechat: '微信'
            },
            joinRivai: {
                title: '加入睿思',
                recruit: '社会招聘'
            },
            followUs: {
                follow: '关注我们',
            }
        }
    },
    bodyOverview: {
        bodyOverview: {
            rivai: '睿思芯科',
            rivaiHPApp: '赋能高性能应用',
            rivaiDescText: '聚焦智能算力需求和数据中心场景为全球客户提供核心技术的弹性供应链选择',
            more: '了解更多',
            joinUs: '加入我们',
            aboutUs: '关于我们',
            knowMoreInfo: '了解更多资讯',
            aboutUsDes: '睿思芯科创立于 2018 年，是中国最早进行RISC-V高端处理器设计的公司之一。创始团队来自于加州大学伯克利分校RISC-V原创项目组，汇集国内外微架构设计和芯片产品化的高水平人才',
            newsTitle: '新闻动态',
            newsTitleDes: '了解企业动向与行业最新消息',
            p600: '高算力 RISC-V 边缘计算处理器',
            data_center: '存储',
            audio: '音频',
            image: '图像',
            video: '视频',
            Industrial: '工控',
            network: '网络',
            communication: '通信',
            btn_text: '进一步了解',
            btn: '回看发布会',
            productList: {
                btnDes: '进一步了解',
                cpuLingyu: '灵羽处理器'
            },
            message: {
                title: '“每一行代码都是在中国，由中国工程师敲出来的。”',
                content: '创始人谭章熹博士拥有清华大学电子工程系学士和硕士学位，加州大学伯克利分校计算机科学硕士和博士学位，师从以研发精简指令集计算机授勋 2017 年度图灵奖的大卫·帕特森教授。',
                des: '创始人寄语'
            }
        }
    },
    bodyAbout: {
        cooperate: "合作咨询",
        aboutRivai: '关于睿思',
        bodyAbout: {
            investmentEndorsement: {
                title: '投资背书',
                info: '创立以来，睿思芯科获得多家顶级投资机构背书'
            },
            founderProfile: '创始人简介',
            slogan: "致力于实现高端 CPU 自主可控",
            buttonNames1: "公司简介",
            buttonNames2: "发展历程",
            buttonNames4: "荣誉与奖项",
            aboutus: "关于我们",
            rewards: "荣誉与奖项",
            rewardslower: "持续精进、屡获殊荣的金牌团队",
            viewofvaluepre: "具备创新活力和内生动力的组织文化，是我们应对挑战与机遇的基石",
            viewofvalue: "企业价值观",
            viewofvaluelower: "我们鼓励知识共享、倡导自由交流、包容不同想法、允许开放争议、追求极致专业，让个体持续创新和全力以赴的潜能，汇聚成开源的力量。",
            contactus: "联系我们",
            shenzhen: "深圳",
            headquarter: "总部",
            shenzhenaddresslast: "广东省深圳市前海深港合作区",
            chengdu: "成都",
            hongkong: '香港',
            hongkongAddr: '香港新界香港科学园',
            subcompany: "子公司",
            chengduaddresslast: "四川省成都市高新区",
            infocowork: "商务合作",
            inforecruit: "简历投递",
            infotel: "公司总机",
            recruit: "加入我们",
            recruitslogan: "一起奔跑，改变世界",
            recruitlinkto: "探索你感兴趣的职位",
            recruitgrow: "助力成长",
            recruitgrowContent: "富有挑战和影响力的工作内容，最前沿的知识和技术，与顶尖芯片工程师共事，引领你发现更多可能",
            recruitlive: "关怀生活",
            recruitliveContent: "健全的员工社会保险和医疗保障、多样的健康关怀、丰富的团建活动，快乐工作、健康生活",
            recruitdev: "关注发展",
            recruitdevContent: "针对性的培训项目、具有竞争力的薪酬激励体系和伴随公司发展的晋升空间，全方位赋能个人发展",
            recruittollerance: "包容个性",
            recruittolleranceContent: "自由包容的文化氛围，高效开放的办公环境，实行弹性灵活的工作机制，效率为先、结果导向",

            aboutT1: '睿思芯科由谭章熹博士于2018年创立，',
            aboutT2: '是中国最早进行RISC-V高端处理器设计的公司之一。创始团队',
            aboutT3: '来自于加州大学伯克利分校RISC-V原创项目组，',
            aboutT4: '汇集国内外微架构设计和芯片产品化的高水平人才。',
            aboutT5: '团队致力于打造新一代云原生CPU，赋能云计算、云存储、5G/6G网络等高性能应用场景，聚焦智能算力需求和数据中心场景。',
            aboutT6: '联合商业与生态合作伙伴，推动云原生CPU的发展，为全球客户提供核心技术',
            aboutT7: '的弹性供应链选择，构建和促进RISC-V生态繁荣。'
        },
        devProgress: {
            growthExp: "发展历程",
            growthExpLower: "顺应潮流，积极应变",
            process1: {
                name: "2023",
                items: [{
                    time: "3月",
                    content: "获川创投数千万元战略融资；荣获深圳市“专精特新企业”称号"
                }
                ]
            },
            process2: {
                name: "2022",
                items: [{
                    time: "5月",
                    content: "荣获投中网“2021年度中国半导体与集成电路产业最佳投资案例TOP10”"
                },
                    {
                        time: "6月",
                        content: "发布高算力RISC-V向量处理器"
                    },
                    {
                        time: "12月",
                        content: "发布边缘计算处理器 RiVAI P600；获得国家级高新技术企业认定"
                    }
                ]
            },
            process3: {
                name: "2021",
                items: [{
                    time: "1月",
                    content: "与全球半导体头部企业签署合同落地边缘端应用"
                },
                    {
                        time: "9月",
                        content: "完成 A＋ 轮融资，字节跳动及高瓴创投领投，多个知名机构跟投；与全球领先通讯服务商签署合同，布局高端处理器"
                    },
                    {
                        time: "12月",
                        content: "获得2021年度深圳天使母基金天使项目优秀企业；获得钛媒体2021年度前沿科技创新企业；获得第二十三届中国国际高新技术成果交易会优秀产品奖"
                    }
                ]
            },
            process4: {
                name: "2020",
                items: [{
                    time: "7月",
                    content: "32位芯片流片成功"
                },
                    {
                        time: "10月",
                        content: "获得第九届中国创新创业大赛全国总决赛优秀企业奖"
                    },
                    {
                        time: "12月",
                        content: "64位芯片流片成功"
                    }
                ]
            },
            process5: {
                name: "2019",
                items: [{
                    time: "1月",
                    content: "自研芯片获得由中国开放指令生态（RISC-V）联盟前沿芯片奖"
                },
                    {
                        time: "3月",
                        content: "完成 A 轮融资，北极光、创新梦工场等知名机构跟投"
                    },
                    {
                        time: "7月",
                        content: "获得由雷锋网评选的最佳产品成长奖"
                    }
                ]
            },
            process6: {
                name: "2018",
                items: [{
                    time: "8月",
                    content: "在深圳成立"
                },
                    {
                        time: "11月",
                        content: "推出基于RISC-V的64位可编程芯片"
                    }
                ]
            },
        },
        managerTeam: {
            tanboInto: "清华大学电子工程系学士、硕士，加州大学伯克利分校计算机科学博士，师从2017年图灵奖得主大卫·帕特森教授，在伯克利期间直接参与了RISC-V技术的研发与推广工作。",
            tanboMore: "了解更多",
            tanboMoreName: "谭章熹 博士",
            tanboMoreTitle: "创始人，董事会主席，CEO",
        },
        tanboDetail1: '谭章熹博士，清华大学电子工程系学士、硕士，加州大学伯克利分校计算机科学博士，师从2017年图灵奖得主大卫·帕特森教授，在伯克利期间直接参与了RISC-V技术的研发与推广工作。',
        tanboDetail2: '之后他以创始工程师的身份加入了美国Pure Storage（NYSE: PSTG）公司并成为其首位芯片设计师，主导开发的企业级闪存服务器FlashBlade获2017年AIconics硬件最佳发明奖；2017年创立自动驾驶芯片公司OURS Technologies，后由行业龙头Aurora（NASDAQ: AUR）收购。作为微处理器、闪存与硬件加速器领域专家，他拥有数十项发明专利。2018年谭博士创立了睿思芯科，从事高性能RISC-V处理器的商业化落地。'
    },
    recruitPage: {
        recruitList: {
            all: "全部",
            shenzheng: "深圳",
            chengdu: "成都"
        },
        recuitDetail: {
            apply: "立即申请",
            copy: "career@rivai.ai | 复制到剪贴板",
            copy_success: "复制成功",
            copy_failed: "复制失败",
        }
    },
    product: {
        unknownError: '未知错误',
        cannotBeNull: '不能为空',
        invalidEmail: '邮箱的格式不正确',
        plzFillInfo: '请完善信息后提交',
        contactValidate: '联系方式验证',
        plzInputForm: '请填写以下信息以访问产品资料',
        validMsg: '信息验证',
        finishValid: '完成验证',
        name: '姓名',
        company: '公司/机构',
        usage: '用途',
        usage1: '工程与研发',
        usage2: '商务与采购',
        usage3: '学术与教育',
        usage4: '媒体与报道',
        usage5: '其他用途',
        tel: '联系电话',
        email: '邮箱地址',
        msgUseInConsult: '您的信息仅用于产品咨询和服务支持',
        cancel: '取消',
        submit: '提交',
        validSuccess: '验证成功！',
        moreConsult: '更多产品信息请咨询我们！',
        enterDownload: '进入下载中心',
        cooperateConsult: '合作咨询',
        bizCooperate: '业务合作或产品咨询',
        contentConsult: '咨询内容',
        finishSubmit: '完成提交',
        cooperateIntent: '合作意向或咨询内容',
        iRead: '我已阅读并同意',
        rivaiPrivate: 'RiVAI 隐私权政策',
        sendEmail: '或投递至邮箱',
        submitSuccess: '提交成功！',
        asaContact: '我们会尽快与您取得联系，期待与您的合作！',
        back: '返回',
        docDownload: '资料下载',
        knowMoreFurther: '可进一步了解更多产品信息',
        disagreePrivate: '您未同意 RiVAI 隐私权政策',
        close: '关闭',
        downloadCenter: '下载中心',
        downloadProduct: '产品资料下载 助力技术开发',
    }
}
export default zh;